export class MapExtra<K, V> extends Map<K, V> {
    public getOrThrow(key: K): V {
        if (!this.has(key)) {
            throw new Error(`Key ${key} not found in map`)
        }

        return this.get(key)!
    }

    public getOrSet(key: K, value: V): V {
        if (!this.has(key)) {
            this.set(key, value)
        }

        return this.get(key)!
    }

    public getKeysAsArray(): K[] {
        return Array.from(this.keys())
    }

    public getValuesAsArray(): V[] {
        return Array.from(this.values())
    }

    // 1) Notice the special `this: MapExtra<K, T[]>` signature
    // 2) Return `T[]`, ensuring we return an array or empty array
    public getArrayOrEmpty<T>(this: MapExtra<K, T[]>, key: K): T[] {
        if (!this.has(key)) {
            return []
        }
        return this.get(key)!
    }

    public getManyOrThrow(keys: K[]): V[] {
        return keys.map((key) => this.getOrThrow(key))
    }
}
